import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TableComponent } from '../components/table/table.component';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { AdminService } from '../../services/adminService';
import { DataUtils } from '../utils/DataUtils';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Observable, of, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DistrictService } from '../../services/districtService';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ApiService } from '../../services/apiservice';
import { DatePickerModule } from 'primeng/datepicker';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { MyMonitoringService } from '../../services/logging.service';

@Component({
  selector: 'app-orders-by-date-modified',
  standalone: true,
  imports: [ButtonModule, ToastModule, TableComponent, DatePickerModule, DatepickerComponent, DropdownComponent, ProgressSpinnerModule, FormsModule, ConfirmPopupModule],
  templateUrl: './orders-by-date-modified.component.html',
  styleUrl: './orders-by-date-modified.component.scss',
  providers: [MessageService, AdminService, DatePipe, ConfirmationService]
})

export class OrdersByDateModifiedComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;
  router: any;
  param: any;
  lsNorthDataColumns: any[] = [];
  processMessage: string = "";
  actionButtons: any = [];
  updateDateOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtOptions: SelectItem[] = [];
  scheduledDateOptions: SelectItem[] = [];
  updateDateCollection: any;
  selectedUpdateDate: string = "";
  isLoading: boolean = false;
  pageSize: number = 10;
  totalRecords: number = 2000;
  selectedType: any;
  selectedDistrict: any;
  selectedSchedDate: string = "";
  allUpdateDateData: any[] = [];
  queryData: any = {};
  sortField: string = "";
  sortOrder: number = 1;
  searchText: any = "";

  filteredData$!: Observable<any[]>;
  currentPage: number = 1;

  constructor(
    private route: ActivatedRoute,
    private adminService: AdminService,
    private districtService: DistrictService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private monotoringService: MyMonitoringService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private apiService: ApiService
  ) {
    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });

    const temp = JSON.parse(sessionStorage.getItem("queryData")!);
    this.queryData = temp;

    if (temp) {
      this.selectedDistrict = temp.data.District;
      this.selectedSchedDate = temp.data.SchedDate;
      this.selectedType = temp.data.Type;
      this.selectedUpdateDate = temp.data.UpdateDate
      this.getSelectedOrderDetails();
      sessionStorage.removeItem("queryData")
    }
    this.LoadHeader();
    this.LoadDistricts();
  }

  LoadDistricts(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId => this.districtService.getDistricts(groupId))
    ).subscribe({
      next: (data: any) => {
        this.districtOptions = DataUtils.createUniqueSortedList(data?.Payload.DistrictData.map((district: any) => ({
          label: district.District.trim(),
          value: district.District
        })));
        this.typeOptions = DataUtils.createUniqueSortedList(data?.Payload.OrderTypeData.map((type: any) => ({
          label: type.Value.trim(),
          value: type.Value
        })));
        if (this.queryData) {
          this.queryData = undefined;
        }
      },
      error: error => {
        this.isLoading = false;
        this.processMessage = '';
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'OrdersByDateModifiedComponent.LoadDistricts', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
        this.processMessage = '';
      }
    });
  }

  onUpdateDateChange(event: any) {
    this.selectedUpdateDate = event;
  }

  LoadHeader(): void {
    this.lsNorthDataColumns = [
      { "field": "UpdateDate", "header": "UPDATED", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "SchedDate", "header": "SCHED DATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      {
        "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action",
        isClickable: 'true', onclick: this.handleClick.bind(this)
      }
    ];
  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);
    const temp = {
      data: {
        UpdateDate: this.selectedUpdateDate,
        Type: this.selectedType,
        District: this.selectedDistrict,
        SchedDate: this.selectedSchedDate
      },
      from: "/orders-by-date-modified"
    }
    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }

  reload() {
    this.tblConfig.clear();
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onCellClicked(event: any[]) {

  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  onDistrictChange(event: any) {
    this.selectedDistrict = event;
  }

  onScheduledDateChange(event: any) {
    this.selectedSchedDate = event;
  }

  getSearchDisabledStatus() {
    return this.selectedUpdateDate === ""
  }

  onSearch(): void {
    this.currentPage = 1;
    this.tblConfig.resetPage();
    this.getSelectedOrderDetails();
  }

  onClear(): void {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {
        this.selectedType = "";
        this.selectedUpdateDate = "";
        this.selectedSchedDate = "";
        this.selectedDistrict = "";
        this.selectedDistrict = "";
        this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },
    });
  }

  getSelectedOrderDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.apiService.groupId().pipe(
      switchMap(groupId => 
      {
          const payload = {
            UpdateDate: this.selectedUpdateDate === "" ? null : this.selectedUpdateDate,
            Type: this.selectedType === "" ? null : this.selectedType,
            District: this.selectedDistrict === "" ? null : this.selectedDistrict,
            SchedDate: this.selectedSchedDate === "" ? null : this.selectedSchedDate,
            userId: sessionStorage.getItem('userId'),
            PageNumber: this.currentPage,
            PageSize: this.pageSize,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            SearchText: this.searchText,
            groupId: groupId
          }

        return this.adminService.getAdminDateModifiedOrders(payload);
      }
      )
    ).subscribe({
      next: (data: any) => {
        const totalRec = data?.Payload?.TotalRecords;
        const updatedData = data?.Payload?.Data.map((item: any) => {
          return {
            ...item,
            UpdateDate: this.datePipe.transform(new Date(item.UpdateDate.trim()), "MM-dd-yyyy")?.toString(),
            SchedDate: this.datePipe.transform(new Date(item.SchedDate.trim()), "MM-dd-yyyy")?.toString()
          }
        });

        this.filteredData$ = of(updatedData);
        this.totalRecords = totalRec;
        this.isLoading = false;

        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Error occurred while retreiving orders by date modified.', detail: errMsg });
        this.isLoading = false;
        this.monotoringService.logException({ name: 'OrdersByDateModifiedComponent.getSelectedOrderDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }

    });
  }

  onPageChanged(event: any): void {
    const pageSize = event.pageSize;
    const pageNumber = event.page;
    this.currentPage = pageNumber;
    this.pageSize = pageSize;
    this.getSelectedOrderDetails();
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.currentPage = 1
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.getSelectedOrderDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedOrderDetails();
  }
}
